import { Component, Inject, OnInit } from '@angular/core';
import { PortalService } from '../../../core/services/portal.service';
import { faUserMd } from '@awesome.me/kit-bde9a98016/icons/sharp/solid';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import {
	AhsCollectorSaveLaterModel,
	AhsComponentModel,
	CollectorService,
	CustomComponentModel
} from '@nx-ahs/script-collector';
import { EnrollmentDashboardService } from '../../../core/services/enrollment-dashboard.service';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AhsTranslationService } from '@nx-ahs/base-translate';
import { AccountService } from '../../../core/services/account.service';
import { NavController, ToastController } from '@ionic/angular';
import { ActivatedRoute, Router } from '@angular/router';
import { AHSTripettoComponent } from '@nx-ahs/script-collector';
import { EnrollmentConfirmationEmailModel } from '../../../shared/models/enrollment/enrollment-confirmation-email.model';

@Component({
	selector: 'benefits-change',
	templateUrl: './benefits-change.component.html',
	styleUrls: ['./benefits-change.component.scss'],
	standalone: false
})
export class BenefitsChangeComponent extends AHSTripettoComponent implements OnInit {
	linkedEntityId: number;
	linkedEntityNameId: number;
	accountId: number;
	scriptId: number;
	icon: any[];
	title: string;
	account: any;
	personSelectLabel: string;
	personSelectFilter: string;
	usePersonSelect: boolean;
	showSinglePagePersonSelect: boolean;
	scriptMode: string;
	translateInstructions: string;
	translateTitle: string;
	translateSuccess: string;
	translateCancel: string;
	public loading: boolean = true;

	state: any;
	public hasEligibleMembers: boolean = false;
	public collectorArray: AhsCollectorSaveLaterModel[];
	public instructionIcon: IconDefinition = faUserMd;

	constructor(
		private router: Router,
		private portalService: PortalService,
		private accountService: AccountService,
		private ahsTranslationService: AhsTranslationService,
		private navController: NavController,
		private route: ActivatedRoute,
		public toastController: ToastController,
		private collectorService: CollectorService,
		private enrollmentDashboardService: EnrollmentDashboardService,
		@Inject(MAT_DIALOG_DATA) private data
	) {
		super();

		if (this.router.getCurrentNavigation()?.extras?.state) {
			const state = this.router.getCurrentNavigation()?.extras?.state;
			this.data = state.data;
		}

		this.scriptSetup();
	}

	async ngOnInit() {
		this.loading = true;
		this.loading = false;
	}

	public async onFinished($event: any): Promise<void> {
		this.enrollmentDashboardService.setCollectorArray(this.collectorArray); // update the collectorArray before leaving
		let emailModel: EnrollmentConfirmationEmailModel;

		//Get the TransactionConfirmationNumber from the form just submitted
		try {
			const response = await this.portalService.getTransactionConfirmationNumber(this.accountId).toPromise();

			emailModel = {
				email: response.email,
				transactionConfirmationNumber: response.transactionConfirmationNumber,
				currentPlan: response.currentPlan,
				myCareIsOptIn: response.isOptIn,
				pendingEffectiveDate: response.pendingEffectiveDate,
				firstName: response.firstName,
				templateKey: 'MYCARE_TRANSACTION_CONFIRMATION_NUMBER'
			};
		} catch (error) {
			console.error(error);
		}

		//send email to user
		await this.portalService.sendTransactionConfirmationNumberEmail(emailModel).toPromise();

		const success = await this.toastController.create({
			message: await this.ahsTranslationService.get(this.translateSuccess).toPromise(),
			position: 'bottom',
			color: 'success',
			duration: 10000,
			buttons: [
				{
					text: await this.ahsTranslationService.get(this.translateCancel).toPromise(),
					role: 'Cancel'
				}
			]
		});
		if (this.collectorArray == null) {
			//don't show success message on single action in a dashboard
			success.present();
		}

		const members = await this.portalService.getPortalEntitiesByCurrentAccount(true);
		this.portalService.accountEntitiesChanged.emit(members);
		this.navController.navigateRoot(['../'], { relativeTo: this.route, animated: false });
	}

	public onCancel($event: boolean): void {
		this.navController.navigateRoot(['../'], { relativeTo: this.route, animated: false });
	}

	private scriptSetup() {
		if (this.data.args) {
			Object.keys(this.data.args).forEach((key) => {
				this.collectorService.getSetGlobalVariables('collector.args.' + key, this.data.args[key]);
			});
		}

		this.scriptId = this.data.scriptId;
		this.title = this.data.title;
		this.translateInstructions = this.data.translateInstructions;
		this.translateTitle = this.data.translateTitle;
		this.translateSuccess = this.data.translateSuccess;
		this.translateCancel = this.data.translateCancel;
		this.icon = this.data.icon;
		this.scriptMode = this.data.scriptMode;
		this.accountId = this.data.accountId;
		this.usePersonSelect = this.data?.usePersonSelect;
		this.showSinglePagePersonSelect = this.data?.showSinglePagePersonSelect;
		this.personSelectLabel = this.data.personSelectLabel;
		this.personSelectFilter = this.data.personSelectFilter;
		if (this.accountId == null) {
			this.accountId = this.accountService.selectedAccountId;
		}

		if (this.data.linkedEntityId) {
			this.linkedEntityId = this.data.linkedEntityId;
			this.linkedEntityNameId = this.data.linkedEntityNameId;
		}
	}
}
